import React, { ReactNode } from 'react';

interface CardProps {
  title?: string;
  icon?: ReactNode;
  children: ReactNode;
  className?: string;
}

const Card: React.FC<CardProps> = ({ title, icon, children, className = '' }) => {
  return (
    <div className={`glass-panel rounded-2xl overflow-hidden hover-card ${className}`}>
      {(title || icon) && (
        <div className="px-6 py-5 border-b border-white/10 dark:border-slate-700/50 flex items-center bg-gradient-to-r from-slate-50/50 to-transparent dark:from-slate-800/50 dark:to-transparent">
          {icon && <span className="mr-3 text-indigo-500 dark:text-indigo-400 drop-shadow-sm">{icon}</span>}
          {title && <h2 className="text-lg font-bold text-slate-800 dark:text-slate-100 tracking-tight">{title}</h2>}
        </div>
      )}
      <div className="p-6">
        {children}
      </div>
    </div>
  );
};

export default Card;